import React, { useEffect, useState, useRef } from "react";
import { politicalPartyUsersService } from "../services/PoliticalPartyUsersService";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { formatDate, formatDateTime } from "../config/Config";
import PoliticalPartyService from "../services/PoliticalPartyService";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { Image } from "primereact/image";
import { Checkbox } from "primereact/checkbox";
import TextInput from "../componets/TextInput";

const PoliticalPartyUsers = () => {
	var politicalPartyService = new PoliticalPartyService();
	const [politicalpartyusersData, setPoliticalPartyUsersData] = useState([]);
	const [loading, setLoading] = useState(false);
	const toast = useRef(null);
	const [showUserDialog, setshowUserDialog] = useState(false);
	const [selectedUser, setselectedUser] = useState(null);
	const [politicalPartiesData, setPoliticalPartiesData] = useState([]);
	const [selectedPoliticalParty, setselectedPoliticalParty] = useState(null);
	const [partyId, setpartyId] = useState(null);
	const [showUpdate, setshowUpdate] = useState(false);

	useEffect(() => {
		GetAll();
		GetAllPoliticalParties();
	}, [showUpdate]);

	async function GetAllPoliticalParties() {
		try {
			const data = await politicalPartyService.getAllPoliticalParties();
			console.log("Fetched Political Parties:", data.politicalParties);
			setPoliticalPartiesData(data.politicalParties);
		} catch (error) {
			console.error("Error fetching political parties:", error);
		}
	}

	function GetAll() {
		setLoading(true);
		politicalPartyUsersService
			.getAll({ Search: " ", PageIndex: 1, PageSize: 10000 })
			.then((data) => {
				console.log(data);
				setPoliticalPartyUsersData(data.users);
			})
			.catch(() => {
				toast.current.show({
					severity: "error",
					summary: "Error",
					detail: "Failed to fetch users",
					life: 2500
				});
			})
			.finally(() => setLoading(false));
	}

	const [showEditUser, setshowEditUser] = useState(false);

	const actionTemplate = (rowData) => {
		return (
			<div className="flex gap-2">
				{/* <Button
					icon="pi pi-pencil"
					className="p-button-rounded p-button-success"
					tooltip="Edit User"
					onClick={() => {
						setshowEditUser(true);
						setselectedUser(rowData);
					}}
				/> */}
				<Button
					icon="pi pi-eye"
					className="p-button-rounded p-button-sm"
					tooltip="View Details"
					onClick={() => {
						setshowUserDialog(true);
						setselectedUser(rowData);
						console.log(rowData);
					}}
				/>
			</div>
		);
	};

	function userRowData() {
		return [
			{
				col1: "Full Names",
				col2: selectedUser?.displayName,
				col3: "Username",
				col4: selectedUser?.username
			},
			{
				col1: "Email Address",
				col2: selectedUser?.email,
				col3: "Status",
				col4: selectedUser?.active ? "Active" : "Not Active"
			},
			{
				col1: "Political Party",
				col2: selectedUser?.politicalParty,
				col3: "",
				col4: formatDate(selectedUser?.appointment?.dateEmployed)
			},
			{
				col1: "Created Date",
				col2: formatDateTime(selectedUser?.createdDate),
				col3: "Created By",
				col4: selectedUser?.createdBy
			}
		];
	}

	const handlePoliticalParty = (data) => {
		setselectedPoliticalParty(data);
		setshowUpdate(true);
	};

	console.log(selectedPoliticalParty);

	const handleAddParty = () => {
		let payload = {
			isCandidate: selectedUser?.isCandidate,
			politicalPartyID: selectedPoliticalParty?.politicalPartyID,
			candidateID: selectedUser?.isCandidate ? selectedUser?.candidateID : null
		};
		politicalPartyUsersService
			.update(selectedUser?.politicalPartyUserID, payload)
			.then((response) => {
				if (response?.success) {
					toast.current.show({
						severity: "success",
						detail: "Party updated successfully",
						life: 2500
					});
					setshowUpdate(false);
					setshowUserDialog(false);
				} else {
					toast.current.show({
						severity: "error",
						detail: response?.message,
						life: 2500
					});
				}
			})
			.catch((error) => {
				console.error("Error updating political party:", error);
			});
		console.log(payload);
	};

	const [isUserCandidate, setisUserCandidate] = useState(false);
	const [checked, setChecked] = useState(selectedUser?.isCandidate);

	const handleCandidate = (event) => {
		setisUserCandidate(event.target.checked);
	};
	const partyDetails = politicalPartiesData.find((party) => party.politicalPartyID === selectedUser?.politicalPartyID);

	function partyRowData() {
		return [
			{
				name: "Party name",
				value: partyDetails?.name
			},
			{
				name: "Abbreviation",
				value: partyDetails?.abbreviation
			},
			{
				name: "Description",
				value: partyDetails?.description
			},
			// {
			// 	name: "Slogan",
			// 	value: partyDetails?.slogan
			// },
			{
				name: "Date Registered",
				value: partyDetails?.registeredDate?.split("T")[0]
			},
			// {
			// 	name: "Anniversary",
			// 	value: partyDetails?.annivesary?.split("T")[0]
			// },
			// !selectedUser?.isCandidate && (
			// 	{
			// 		name: <label>Select Political Party <span style={{color:"red"}}>*</span> </label>,
			// 		value: (<Dropdown
			// 			value={selectedPoliticalParty}
			// 			onChange={(e) => handlePoliticalParty(e.value)}
			// 			options={politicalPartiesData}
			// 			optionLabel="name"
			// 			placeholder="Select a Party"
			// 			className="w-full"
			// 		/>)
			// 	}
			// ),
			!showEditUser
				? {
						name: "Logo",
						value: (
							<Image
								preview={true}
								src={partyDetails?.logo}
								template="Logo"
								alt="Logo"
								width="100px"
								style={{ width: "100px", objectFit: "cover" }}
							/>
						)
					}
				: null
			// {
			// 	name: <label>{selectedUser?.isCandidate ? " Make user a Candidate" : " Remove user as candidate"} <span style={{color:"red"}}>*</span></label>,
			// 	value: (
			// 		<>
			// 		<Checkbox
			// 						inputId="candidateCheckbox"
			// 						checked={selectedUser?.isCandidate}
			// 						value={selectedUser?.isCandidate}
			// 						onChange={(e) => {
			// 							setselectedUser({
			// 								...selectedUser,isCandidate :!selectedUser?.isCandidate
			// 							})
			// 						}}
			// 						style={{ marginTop: "5px", paddingLeft: "2px" }}
			// 					/>
			// 					</>
			// 	)
			// },
		];
	}

	function removeNulls(data = []) {
		console.log(data);
		console.log(data.filter((e) => e !== null));
		return data.filter((e) => e !== null);
	}
	return (
		<div className="card p-align-stretch vertical-container" style={{ height: "100%" }}>
			<Toast ref={toast} />
			<Dialog
				draggable={false}
				onHide={() => {
					setshowEditUser(false);
				}}
				visible={showEditUser}
				style={{ width: "80%", height: "70vh" }}
				modal
				header={
					<>
						<i className="pi pi-eye"></i>
						<span>{` Edit User Details -  ${selectedUser?.displayName} (${selectedUser?.email})`}</span>
					</>
				}
				footer={
					<div>
						{selectedPoliticalParty && (
							<Button
								icon="pi pi-save"
								label="Update"
								disabled={!selectedPoliticalParty}
								onClick={handleAddParty}
								className="p-button-success"
							/>
						)}
						<Button
							icon="pi pi-times-circle"
							label="Close"
							onClick={(e) => {
								setshowEditUser(false);
							}}
							className="p-button-danger ml-2"
						/>
					</div>
				}
			>
				<div>
					{!selectedUser?.isCandidate ? (
						<div>
							<DataTable
								size="small"
								scrollable={true}
								value={removeNulls(partyRowData())}
								dataKey="id"
								responsiveLayout="scroll"
								resizableColumns
								showHeaders={false}
							>
								<Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
								<Column body={(e) => e.value}></Column>
							</DataTable>
							{/* <br />
							<Dropdown
								value={selectedPoliticalParty}
								onChange={(e) => handlePoliticalParty(e.value)}
								options={politicalPartiesData}
								optionLabel="name"
								placeholder="Select a Party"
								className="w-full my-2"
							/>
							<br /> */}
							{/* {selectedPoliticalParty && (
								<div style={{ marginTop: "10px", marginBottom: "10px" }}>
									<div>
										Selected Party: <strong> {selectedPoliticalParty?.name} </strong>
									</div>
								</div>
							)} */}
						</div>
					) : (
						<>
							<DataTable
								size="small"
								scrollable={true}
								value={partyRowData().filter((e) => e !== null)}
								key={selectedUser?.isCandidate}
								dataKey="id"
								responsiveLayout="scroll"
								resizableColumns
								showHeaders={false}
							>
								<Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
								<Column body={(e) => e.value}></Column>
							</DataTable>
							{/* <TextInput value={`${selectedUser?.displayName} ${selectedUser?.isCandidate ? "is not a" : "is a"} candidate`} disabled /> */}
							{/* <label htmlFor="candidateCheckbox" className="p-checkbox-label">
								<Checkbox
									inputId="candidateCheckbox"
									checked={checked}
									onChange={(e) => setChecked(!selectedUser?.isCandidate)}
									style={{ marginTop: "5px", paddingLeft: "2px" }}
								/>
								{selectedUser?.isCandidate ? " Make user a Candidate" : " Remove user as candidate"}
							</label>{" "} */}
						</>
					)}
				</div>
			</Dialog>
			<Dialog
				draggable={false}
				onHide={() => {
					setshowUserDialog(false);
				}}
				visible={showUserDialog}
				style={{ width: "80%", height: "98vh" }}
				modal
				header={
					<>
						<i className="pi pi-eye"></i>
						<span>{` User Details -  ${selectedUser?.displayName}  (${selectedUser?.email})`}</span>
					</>
				}
				footer={
					<div>
						<Button
							icon="pi pi-save"
							label="Update"
							onClick={handleAddParty}
							className="p-button-success hidden d-none"
							disabled={selectedPoliticalParty === null}
						/>

						<Button
							icon="pi pi-times-circle"
							label="Close"
							onClick={(e) => {
								setshowUserDialog(false);
							}}
							className="p-button-danger"
						/>
					</div>
				}
			>
				<TabView>
					<TabPanel header="User Details">
						<DataTable
							size="small"
							scrollable={true}
							dataKey="id"
							className="datatable-responsive"
							responsiveLayout="scroll"
							resizableColumns
							columnResizeMode="expand"
							value={userRowData()}
						>
							<Column field="col1" body={(e) => <b>{e.col1}</b>}></Column>
							<Column field="col2"></Column>
							<Column field="col3" body={(e) => <b>{e.col3}</b>}></Column>
							<Column field="col4"></Column>
						</DataTable>
					</TabPanel>
					{!selectedUser?.isCandidate && (
						<TabPanel header="Political Party Details">
							<DataTable size="small" scrollable={true} value={partyRowData()} dataKey="id" responsiveLayout="scroll" resizableColumns>
								<Column style={{ width: "100px" }} body={(e) => <b>{e?.name}</b>}></Column>
								<Column body={(e) => e?.value}></Column>
							</DataTable>
						</TabPanel>
					)}
				</TabView>
			</Dialog>
			<h3>Political Party Users</h3>
			<DataTable
				size="small"
				scrollable
				value={politicalpartyusersData}
				dataKey="politicalPartyUserID"
				paginator
				rows={5}
				rowsPerPageOptions={[5, 10, 15]}
				className="datatable-responsive"
				emptyMessage="No users found."
				loading={loading}
				resizableColumns
				columnResizeMode="expand"
			>
				<Column field="email" header="Email" sortable></Column>

				<Column field="displayName" header="Name" sortable></Column>
				<Column field="politicalParty" header="Political Party" sortable></Column>
				<Column
					field="isActive"
					header="Status"
					sortable
					body={(e) => {
						return (
							<Button
								label={e?.active ? "Active" : "Not Active"}
								style={{ height: "30px", textAlign: "center" }}
								className={`p-button-rounded  ${e?.active == true ? "p-button-success" : "p-button-danger"}`}
							/>
						);
					}}
				/>
				<Column header="Actions" body={actionTemplate} />
			</DataTable>
		</div>
	);
};

export default PoliticalPartyUsers;
